export const ORDER_BY = {
  ASC: "asc",
  DESC: "desc",
} as const;

export type ORDER_BY = (typeof ORDER_BY)[keyof typeof ORDER_BY];

export const DEBOUNCE_TIME = 300;
export const PER_PAGE = 10;

export const NUMBERS_REGEX = /^\d+$/;

// This regex matches US phone numbers in various formats, including optional country code, area code, and extensions.
//(630-555-5555, 856 573-0022, (616) 403-4936, 8706426444, 920-739-5351 X3028)
export const PHONE_NUMBERS_REGEX =
  /^(?:(?:1[-\/ ])?(?:\(\d{3}\)|\d{3})[-\/ .]?\d{3}[-\/ .]?\d{4}|\d{8}|\d{10})(?:\s*(?:[xX]{3}|[xX]\d+))?$/;

// This regex matches email addresses in the format of local-part@domain, where local-part can contain letters, digits, and special characters, and domain can contain letters, digits, hyphens, and dots.
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const MAX_EMAILS = 25;
